<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="subpage article-detail flex-column-start" ref="articleDetailRef" style="background: #ffffff">
    <Header v-if="$route.query.platform !== 'mini'" title="图文详情" :is-sub-page="true" :is-native-handle="true" ref="navBarRef">
      <template v-slot:rightBtn>
        <span class="btn btn-share" @click="shareClick"></span>
      </template>
    </Header>

    <!--
    <section class="content" ref="contentRef" style="flex: 1; overflow:hidden;">
      <cube-scroll ref="scrollRef">
        <div class="ql-snow">
          <div class="h5-web ql-editor" v-html="this.content"></div>
        </div>
      </cube-scroll>
    </section>
    -->

    <section class="content" ref="contentRef" style="padding-bottom: 0; padding-left: 0; padding-right: 0; flex: 1; overflow:hidden;">
      <div ref="scrollRef" style="overflow: hidden; height: 100%;">
        <div class="ql-snow" style="overflow: auto; height: 100%;">
          <div class="h5-web ql-editor" v-html="this.content"></div>
        </div>
      </div>
    </section>

    <!-- 在小程序上显示 -->
    <template v-if="$route.query.platform === 'mini' && $route.query.type !== '5'">
      <comment ref="commentRef" :course-id="courseId"></comment>
    </template>
  </div>
</template>

<script>
import Header from '../../../components/Header'
import Comment from '../components/Comment'
import { queryCourseDetail, buyCourse } from '@/api/course'
// import { courseShare } from '@/api/course'

export default {
  name: 'CourseDetail',
  components: {
    Header,
    Comment
  },
  data () {
    return {
      courseId: -1,
      title: '',
      content: '',
      courseValue: '',
      courseIsAccess: false,
      su: false
    }
  },
  mounted () {
    console.log(this.$route.query)
    try {
      this.su = this.$route.query.p === 0
    } catch (e) {
      console.error(e.message)
    }

    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }
    this.courseId = parseInt(this.$route.query.id)

    this.$nextTick(() => {
      if (this.$route.query.platform === 'mini') {
        this.$refs.commentRef.getCommentAndLikeCount()
        this.$refs.commentRef.getIsLike()
      }
    })

    setTimeout(() => { this.getData() }, 500)
  },

  methods: {
    getData () {
      let token = this.$store.state.token.token

      console.log('articlDetail token=' + token)
      queryCourseDetail({
        courseId: parseInt(this.$route.query.id)
      }).then((res) => {
        this.title = res.data.name
        this.content = res.data.content
        this.courseValue = res.data.value
        this.courseIsAccess = res.data.accessible
        if (this.su) this.courseIsAccess = true
      })
    },
    buyCourse () {
      this.$createDialog({
        type: 'confirm',
        content: '您还没有权限听课，是否使用' + this.courseValue + '积分购买？',
        confirmBtn: {
          text: '确定',
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: '取消',
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          console.log('确定')
          buyCourse({
            courseId: parseInt(this.$route.query.id)
          }).then((res) => {
            // 购买成功 重新获取
            this.$createToast({
              type: 'alert',
              time: 1000,
              txt: '购买成功'
            }).show()
            this.getData()
          })
        }
      }).show()
    },
    shareClick () {
      console.log('图文 share')

      if (!this.courseIsAccess) {
        // 弹出购买
        this.buyCourse()
        // this.shareCourse()
      } else {
        this.shareCourse()
      }
    },
    shareCourse () {
      console.log('this.route type=' + this.$route.query.type + ' id=' + this.$route.query.id)
      this.$dfzhJsBridge.share({
        url: process.env.VUE_APP_SHARE_URL + '/article/article_detail?type=' + this.$route.query.type + '&id=' + this.$route.query.id + '&p=0',
        title: this.title === '' ? ' ' : this.title,
        description: ' '
      })
    }
  }
}
</script>

<style lang="stylus">
body
  background-color #f7f7f7 !important
.article-detail
  .content
    text-align justify
    color #363636
    font-size 15px
    line-height 22px
    padding-top 15px
    padding-bottom 15px
    box-sizing border-box

  .h5-web
    img
      width 100%
      height auto
</style>
